export enum Languages {
	ENGLISH = "English",
	KOREAN = "한국어"
}
